<div class="close-btn-outer">
    <button mat-mini-fab color="warn" (click)="close()"><mat-icon>close</mat-icon></button>
</div>
<div mat-dialog-content>
  <div class="text-center py-1">
    Пожалуйста введите Email который вы использовали при регистрации
    <form [formGroup]="restorePasswordForm" (ngSubmit)="onRestorePasswordFormSubmit(restorePasswordForm.value)">
      <mat-form-field appearance="outline" class="w-100 mt-2">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" formControlName="restorePasswordEmail" required>
        <mat-error *ngIf="restorePasswordForm.controls.restorePasswordEmail.errors?.required">Email необходим</mat-error>
        <mat-error *ngIf="restorePasswordForm.controls.restorePasswordEmail.hasError('invalidEmail')">Неправильный email</mat-error>
      </mat-form-field>

      <div class="text-center mt-2">
        <button mat-fab color="primary" class="mat-elevation-z6" (click)="onRestorePasswordFormSubmit(restorePasswordForm.value)">
          <mat-icon>restore_page</mat-icon>
        </button>
      </div>

    </form>
  </div>

</div>
